import { ref } from 'vue'
import { profileApi, type UserProfile } from '@/api/profile'

// Shared stored-profile state (null until saved). Prefer this name over the raw
// login claim once the user has saved a profile.
const profile = ref<UserProfile | null>(null)
const loaded = ref(false)

export function useProfile() {
  async function load(force = false) {
    if (loaded.value && !force) return
    try {
      profile.value = await profileApi.get()
    } catch {
      profile.value = null
    }
    loaded.value = true
  }

  async function save(fullName: string, email: string) {
    profile.value = await profileApi.save(fullName, email)
  }

  return { profile, loaded, load, save }
}
